<template lang="pug">
  #app
    div(v-if='isLoadingFullPage')
      loading-full-page
    router-view
    notification(ref='notification')
</template>

<script>
import LoadingFullPage from '../loading/LoadingFullPage'
import Notification from '../notification/Notification'

import 'reset-css/reset.css'
import 'font-awesome/css/font-awesome.css'
import '../../template/assets/plugins/jquery-scrollbar/jquery.scrollbar.css'
import '../../template/pages/css/pages.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../../assets/fonts/fonts.css'
import 'toastr/build/toastr.min.css'
import '../../template/assets/plugins/jquery-scrollbar/jquery.scrollbar.min.js'
import '../../template/assets/plugins/modernizr.custom.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-select/dist/vue-select.css'
import PATHS from '../../router/routesMap'

export default {
  name: 'App',

  components: {
    LoadingFullPage,
    Notification
  },

  data () {
    return {
      intervalRenewToken: null
    }
  },

  computed: {
    isLoadingFullPage () {
      return this.$store.getters.isLoadingFullPage
    }
  },

  mounted () {
    // Adicionando animação simples para carregamento do body
    document.body.classList.remove('fade-out')
    this.$store.dispatch('fullPageLoaded')

    window.addEventListener('storage', event => {
      if (event.newValue === null) {
        return
      }

      switch (event.key) {
        case 'event-login-start':
          localStorage.removeItem('event-login-start')
          break
        case 'event-login-done':
        case 'event-client-selected':
          localStorage.removeItem(event.key)
          location.href = PATHS.HOME
          break
        case 'event-logout':
          localStorage.removeItem(event.key)
          location.href = PATHS.BANKING
          break
        default:
          break
      }
    })
  }
}
</script>

<style>
body {
  font-family: 'Inter', sans-serif;
  opacity: 1;
  transition: 1s opacity;
  margin: 0;
}

body.fade-out {
  opacity: 0;
  transition: none;
}

p,
input {
  font-family: 'Inter', sans-serif !important;
}

.pace-activity {
  display: none !important;
}

.form-group label {
  font-family: 'Inter', sans-serif !important;
}

.v-select input,
.dropdown-toggle {
  font-family: 'Inter', sans-serif;
  background: #fff;
}

.v-select input,
.dropdown-toggle > span {
  font-size: 14px;
  color: #555;
}

.v-select.is-danger {
  border: 1px solid #ff3860;
  border-radius: 4px;
}

.v-select input[type="search"],
.v-select input[type="search"]:focus {
  color: #555;
}

.v-select .selected-tag {
  color: #555;
}

.page-content-wrapper {
  padding-top: 35px;
}

.is-danger {
  border-color: #ff3860;
}

.is-danger input {
  border-color: #ff3860;
}

.is-danger .dropdown-toggle {
  border-color: #ff3860 !important;
}

.form-control.is-danger {
  border-color: #ff3860;
}

.vue-input-tag-wrapper.input.is-danger {
  border-color: #ff3860;
}

.help.is-danger {
  color: #ff3860 !important;
}

.help.is-warning {
  color: #f7ae45;
  font-weight: bold;
}

.help {
  display: block;
  font-size: 11px;
  margin-top: 5px;
}

.row-filter-small {
  margin-top: 10px;
}

.row-filter-medium {
  margin-top: 20px;
}

.row-filter-big {
  margin-top: 30px;
}

/*
CSS Datatable. TODO: Separar em um arquivo
*/
.table-bordered>tbody>tr>td {
  vertical-align: middle
}

.custom-data-table .table-responsive {
  border-radius: 10px !important;
}

.custom-data-table {
  font-family: 'Inter', sans-serif !important;
}

.custom-data-table .table-bordered {
  border: 1px solid #dddddd;
}

.custom-data-table thead:first-child {
  background-color: #1c3b60;
  color: #ffffff !important;
  font-weight: bold;
}

.VueTables__filters-row {
  background-color: white;
}

.VueTables__filters-row > th {
  padding: 0 !important;
  border-bottom: none !important;
}

.VueTables__filters-row > th input{
  transition: all linear 0.1s;
  border: none;
  background: url('../../assets/vue-tables-2/lupa.png') no-repeat;
  background-position: calc(100% - 10px) center;
  background-size: 15px;
  padding: 7px 40px 5px 7px;
  vertical-align: middle;
  line-height: 100%;
  min-height: 15px;
  height: 100%;
  box-shadow: unset;
}

.VueTables__filters-row > th input:focus {
  transition: all linear 0.1s;
  font-weight: bold;
  border: none;
  background: url('../../assets/vue-tables-2/lupa-active.png') no-repeat;
  background-position: calc(100% - 10px) center;
  background-size: 18px;
  box-shadow: unset;
}

.custom-data-table tbody>tr {
  background-color: #ffffff;
}

.custom-data-table tbody>tr:hover {
  background-color: #f3f8fe;
}

.custom-data-table .pagination>.active>a {
  background-color: #1c3b60;
  border-color: #1c3b60;
  color: #fff;
}

.custom-data-table .pagination>li>a {
  color: #1c3b60;
}

.custom-data-table .pagination>li:first-child>a {
  color: #1c3b60;
}

.custom-data-table .pagination>li:last-child>a {
  color: #1c3b60;
}

.custom-data-table .pagination {
  margin: 5px 0;
}

.VueTables__search {
  margin-top: 15px;
}

.table > tbody > tr > td,
.table > tbody > tr > th,
.table > tfoot > tr > td,
.table > tfoot > tr > th,
.table > thead > tr > td {
  padding: 7px 7px 5px 7px !important;
  vertical-align: middle !important;
  line-height: 100% !important;
}

.VueTables__table > tbody > .VueTables__filters-row > td {
  padding: 0px !important;
}

.VueTables__table > thead > tr:first-child > th {
  padding: 7px 7px 5px 7px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* Input tag */
.input-tag {
  background-color: #f3f8fe !important;
  border: 1px solid #cccccc !important;
  color: #1c3b60 !important;
}

.vue-input-tag-wrapper {
  border-radius: 5px;
  border: 1px solid #ccc;
  max-height: 96px;
  overflow-y: auto !important;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  min-height: 36px;
}

.control-label {
  font-family: 'Inter', sans-serif;
  text-transform: initial !important;
  color: #515151;
  font-weight: normal !important;
  font-size: 14px !important;
  margin-top: 10px;
}

.label-export {
  margin-top:1px;
  margin-left:5px;
}

.export-file {
  padding-top:17px;
  margin-right:30px;
}

.optional-label {
  color: #999999;
  font-style: italic;
  margin-left: 10px;
}

.required-label {
  color: #e60000;
  margin-left: 2px;
}

.checkbox label::after {
  top: -1px!important;
  left: 2.2px!important;
  font-size:10px!important;
}

.checkbox label:before {
  top: 2px!important;
}

.checkbox input[type="checkbox"]:checked + label::before {
  border-width: 7.6px!important;
}

.checkbox label:before {
  width: 14px!important;
  height: 14px!important;
}

.radio label:before {
  width: 14px!important;
  height: 14px!important;
  bottom: 0px;
  top: 2.3px;
}

.radio label, .checkbox label {
  padding-left: 18px !important;
  margin-right: 25px !important;
}

button.filter-input-tag {
  width: 100%;
  min-width:auto;
  padding:0px;
  margin: 0px !important;
}

.v-select input[type=search] {
  height: 34px;
  display: block!important;
  border: none!important;
}

.vs__selected-options {
  display: inline-flex!important;
  flex-wrap: nowrap!important;
}

.dropdown.v-select.open input.form-control {
  width: auto !important;
}

.form-control {
  min-height: 34px!important;
}

.text-left {
  text-align: left;
}

.v-select .dropdown-toggle .clear {
  display: none;
}

.d-flex {
  display: flex;
}

.flex-wrap {
  flex-wrap: wrap;
}

.m-0 {
  margin: 0 !important;
}

.mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.ml-0 {
  margin-left: 0 !important;
}

.mr-0 {
  margin-right: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pl-0 {
  padding-left: 0 !important;
}

.pr-0 {
  padding-right: 0 !important;
}

.m-5 {
  margin: 5px !important;
}

.mx-5 {
  margin-left: 5px !important;
  margin-right: 5px !important;
}

.my-5 {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}

.mt-5 {
  margin-top: 5px !important;
}

.mb-5 {
  margin-bottom: 5px !important;
}

.ml-5 {
  margin-left: 5px !important;
}

.mr-5 {
  margin-right: 5px !important;
}

.p-5 {
  padding: 5px !important;
}

.px-5 {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.py-5 {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.pt-5 {
  padding-top: 5px !important;
}

.pb-5 {
  padding-bottom: 5px !important;
}

.pl-5 {
  padding-left: 5px !important;
}

.pr-5 {
  padding-right: 5px !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?6488992a